import { useEffect } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import AboutUsHero from './components/AboutUsHero';
import TrustBar from '../home/components/TrustBar';
import ServicesSection from '../home/components/ServicesSection';
import ExpertiseDifferentiatorsSection from './components/ExpertiseDifferentiatorsSection';
import ProcessSection from '../home/components/ProcessSection';
import CompanyStorySection from './components/CompanyStorySection';
import WorkshopSection from './components/WorkshopSection';
import TestimonialsSection from '../home/components/TestimonialsSection';
import ServiceAreasSection from '../home/components/ServiceAreasSection';
import SpecialOfferSection from '../home/components/SpecialOfferSection';
import AboutFAQSection from './components/AboutFAQSection';
import CTASection from '../home/components/CTASection';
import GallerySection from '../home/components/GallerySection';

const AboutUsPage = () => {
  useEffect(() => {
    document.title =
      'About Custom Clothiers | Bespoke Tailors in Wellesley MA Since 1970';
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <AboutUsHero />
        <TrustBar />
        <ServicesSection />
        <ExpertiseDifferentiatorsSection />
        <ProcessSection />
        <CompanyStorySection />
        <WorkshopSection />
        <TestimonialsSection />
        <ServiceAreasSection />
        <SpecialOfferSection />
        <AboutFAQSection />
        <CTASection />
        <GallerySection />
      </main>
      <Footer />
    </div>
  );
};

export default AboutUsPage;
